<!-- 
Expander panel showing the non-compliance history: short registration period calculation.
-->
<template>
  <div>
    <a
      :id="'focus-' + panelNumber"
      href="#" class="section-heading subheading d-block pl-4 pr-5 pt-3 pb-3"
      @click.stop.prevent="$emit('click:togglePanel', panelShortRegistrationScore)"
    >
      <v-icon class="non-compliance-history-breakdown">subdirectory_arrow_right</v-icon>
      Non-compliance history and registration renewal: Registration renewal value
      <v-btn icon class="focus-button" tabindex="-1">
        <v-icon :class="'expand-icon ' + (expanded ? 'expanded' : '')">expand_more</v-icon>
      </v-btn>
    </a>
    <v-expand-transition>
      <v-card v-show="expanded" flat>
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
        <div v-if="!isInternal" class="caption pl-4 pr-4 pt-2" v-html="templates.ShortRegistrationPeriodScore"/>
        <v-card-text class="pt-2 px-0 pb-0">
          <v-layout row wrap mx-4>
            <v-flex 
              xs12 sm4 mt-2 pt-1 
              class="text-xs-right"
            >
              <our-data-field v-if="sanctioned" label="Short registration renewal period" label-width="11">
                Sanctioned
                <br>
                (maximum risk factor value applies)
              </our-data-field>
              <our-data-field v-if="!sanctioned" label="Short registration renewal period" label-width="11">
                <our-multiline-text :text="shortRegistrationPeriodMeasureText"/>
              </our-data-field>
            </v-flex>
            <v-flex xs12 sm4 pb-4>
              <risk-factor-table
                :estimator-key="estimatorKey" 
                :levy-collection-id="levyCollection.id" 
                :selected-score="levyCalculation.shortRegistrationPeriodMeasure"
                type="ShortRegistrationPeriod" 
                title="Short registration renewal period"
              />
            </v-flex>
            <v-flex 
              xs12 sm4 mt-2 pt-1 
              class="text-xs-right"
            >
              <our-data-field label="Registration renewal value" typography="title" label-width="11">
                {{ levyCalculation.shortRegistrationPeriodScore | numericInput2 }}
                <template v-slot:footer>
                  <playground-up-down v-if="isLevyEstimator" field="shortRegistrationPeriodScore" show-original small/>
                </template>
              </our-data-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import mixins from "./mixins";
import PlaygroundUpDown from "@/components/levy-collection-providers/calculation/PlaygroundUpDown.vue";
import RiskFactorTable from "@/components/levy-collection-providers/calculation/RiskFactorTable.vue";
import PreciseRiskFactorNumber from "@/components/levy-collection-providers/calculation/PreciseRiskFactorNumber.vue";

export default {
  components: {
    PlaygroundUpDown,
    RiskFactorTable,
    PreciseRiskFactorNumber
  },
  mixins: [filterMixins, mixins],
  props: {
    expanded: {
      type: Boolean,
      required: true
    },
    panelNumber: {
      type: Number,
      required: true
    }
  },
  computed: {
    sanctioned() {
      return this.levyParameters.sanctioned && this.levyCollection.enableSanctions;
    },
    shortRegistrationPeriodMeasureText() {
      return this.levyCalculation.shortRegistrationPeriodMeasure === 0 ? "False" : "True";
    }
  }
};
</script>
